import type { Tile } from '@/store/tiles/types.ts';

export type DragState =
  | {
      isDragInProgress: false;
    }
  | {
      isDragInProgress: true;
      draggedTile: Tile;
      tiles: readonly Tile[];
    };

export const dragStateNoDrag: DragState = { isDragInProgress: false };
